/** Fallback si el store aún no tiene `allowedCountriesRfqRemittance` del endpoint. */
export const RFQ_MULTI_TRANSACTION_COUNTRY_CODES_FALLBACK = ['CO'] as const;

/** Producto y país usados en rutas EXCHANGE para `getRfqConfig` (par treasury desk). */
export const RFQ_EXCHANGE_PRODUCT_TYPE = 'EXCHANGE' as const;
export const RFQ_EXCHANGE_ROUTE_COUNTRY_CODE = 'WA' as const;
